import { formatDateToYYYYMMDD } from "src/shared/util/formatDates";
import { config } from "../../configVar";
import { ReduxThunkAction } from "../../store";
import { mainSlice } from "../shared";
import { planningSlice } from "./index";

const serverUrl = config.serverUrl


export const loadAllTasks =
    (status: string | undefined, startDate: Date | string | undefined, endDate: Date | string | undefined, projectId: string | undefined): ReduxThunkAction =>
        async (dispatch, getState) => {

            try {
                dispatch(mainSlice.actions.updateState({ status: true }));

                let token = localStorage.getItem("authToken");

                const headers: any = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                }

                if (startDate && endDate) {
                    headers["start"] = formatDateToYYYYMMDD(startDate);
                    headers["end"] = formatDateToYYYYMMDD(endDate);
                }

                if (status) {
                    headers["status"] = status;
                }

                if (projectId) {
                    headers["projectId"] = projectId;
                }

                const response = await fetch(`${serverUrl}/api/planning/getListOfActivitiesByProject`, {
                    method: "GET",
                    headers: headers,
                });

                const listOfTasks = await response.json();

                dispatch(planningSlice.actions.setPlaningTask(listOfTasks));

            } catch (error) {

            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));

            }

        }

export const updateTask =
    (task: any): ReduxThunkAction =>
        async (dispatch, getState) => {

            try {
                dispatch(mainSlice.actions.updateState({ status: true }));

                let token = localStorage.getItem("authToken");

                const headers: any = {
                    "Content-Type": "application/json",
                    authorization: `${token}`,
                }

                const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivity`, {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify(task)
                });



                const json = await response.json();

                // dispatch(planningSlice.actions.setPlaningTask(listOfTasks));

            } catch (error) {

            } finally {
                dispatch(mainSlice.actions.updateState({ status: false }));

            }

        }


export const updateTaskStatus =
    (task: any): ReduxThunkAction => async (dispatch, getState) => {
        
        try {
            dispatch(mainSlice.actions.updateState({ status: true }));

            let token = localStorage.getItem("authToken");

            const headers: any = {
                "Content-Type": "application/json",
                authorization: `${token}`,
            }

            const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivityStatus`, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(task)
            });

            const json = await response.json();

        } catch (error) {

        } finally {
            dispatch(mainSlice.actions.updateState({ status: false }));

        }
    }